import http from '@/assets/common/http';
// ------------------------------------------退货审核
// ------------------------------------------查询未退货订单功能
export function queryReturnFun() {
  const params = {
    SERVICE_ID: '10028',
    OTYPE: 10,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
  };
  return http.post(params);
}
// ------------------------------------------查询已退货订单功能
export function queryHaveReturnFun(data) {
  const params = {
    SERVICE_ID: '10028',
    OTYPE: 11,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------查询退货凭证功能
export function queryReturnDetailFun(data) {
  const params = {
    SERVICE_ID: '10028',
    OTYPE: 4,
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------拉取模态框数据
export function queryDataFun(data) {
  const params = {
    SERVICE_ID: '10028',
    OTYPE: 14,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// --------------------------------------------供应商同意退货申请功能
export function agreeReturnFun(data) {
  const params = {
    SERVICE_ID: '10028',
    // OTYPE: 7,
    OTYPE: 19,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// --------------------------------------------供应商拒绝退货申请功能
export function refuseReturnFun(data) {
  const params = {
    SERVICE_ID: '10028',
    OTYPE: 5,
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------导出已退货列表数据
export function exportDateFun(data) {
  const params = {
    SERVICE_ID: '10028',
    OTYPE: 15,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------查询退货出库功能
export function queryReturnOutFun(data) {
  const params = {
    SERVICE_ID: '10028',
    OTYPE: 16,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------查询已拒绝退货功能
export function deniedListFun(data) {
  const params = {
    SERVICE_ID: '10028',
    OTYPE: 18,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------退货出库功能
export function returnDataFun(data) {
  const params = {
    SERVICE_ID: '10028',
    OTYPE: 17,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------查询供应链客户退货审核单
export function getGYSCusReturnAuditListFun(data) {
  const params = {
    SERVICE_ID: '10028',
    OTYPE: 25,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------查询供应链客户退货审批详情
export function getGYSCusReturnAuditDetailFun(data) {
  const params = {
    SERVICE_ID: '10028',
    OTYPE: 26,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------同意/拒绝供应链客户退货审批
export function auditGYSReturnFun(data) {
  const params = {
    SERVICE_ID: '10028',
    OTYPE: 27,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/assets/api/returnCheck.js